import axios from "axios";

import APIRoutes from "../../APIRoutes";

import SonicOffer from "../../../common/classes/SonicOffer";

import { getAPIRoot } from "../../../utils/GeneralUtils";
import SonicOfferMeta from "../../../common/classes/SonicOfferMeta";

/**
 * postUpdateOfferAdmin
 *
 * Update offer data from admin page.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param isSelect Whether the request is from jikei or not.
 * @param offer_id ID of the offer information you wish to update.
 * @param status Status of the offer information you wish to update.
 * @param memo Whether the request is from jikei or not.
 * @returns Updated offer data.
 */

export const postUpdateOfferAdmin = async (
  auth_token: string,
  isSelect: boolean,
  offer_id: string,
  status?: string,
  memo?: string
) => {
  try {
    const res = await axios.post(
      getAPIRoot(APIRoutes.post.offer, isSelect ? "admin" : "jikei"),
      {
        sonic_offer_id: offer_id,
        sonic_status: status,
        sonic_memo: memo,
      },
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
      }
    );

    if (res.data.result == false) return null;

    const o = res.data.message.entry.offer;
    const offer = SonicOffer.parseFromAPIResponse(o);
    const meta = SonicOfferMeta.parseFromAPIResponse(
      res.data.message.entry.meta
    );

    return {
      offers: [offer],
      meta: [meta],
    };
  } catch (e) {
    return null;
  }
};
